var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Books',
        to: '/ebooks'
      }],
      "title": "All Books"
    }
  }), _c('div', {
    staticClass: "flex-col w-full bg-white shadow-sm rounded-lg"
  }, [_c('div', {
    staticClass: "w-full flex items-center justify-between rounded-lg px-4 mt-3 mb-2 py-0 pt-3"
  }, [_c('div', {
    staticClass: "w-2/6 relative"
  }, [_c('i', {
    staticClass: "fa-solid fa-magnifying-glass text-gray-400 text-base absolute top-3 left-3"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.query_search,
      expression: "query_search"
    }],
    staticClass: "p-2.5 pl-5 mb-1 w-full text-sm border rounded-lg",
    attrs: {
      "placeholder": "Search File Name or ID",
      "type": "search"
    },
    domProps: {
      "value": _vm.query_search
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.query_search = $event.target.value;
      }, _vm.onSearch],
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onSearch.apply(null, arguments);
      }
    }
  })]), _c('div', {
    staticClass: "relative w-3/4 flex justify-end"
  }, [_c('Button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "default",
      "size": "sm",
      "color": "primary"
    }
  }, [_c('router-link', {
    staticClass: "text-white px-0 py-2 hover:no-underline",
    attrs: {
      "to": {
        name: _vm.ManageFormEbookPath.name
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add New ")])], 1), _c('Button', {
    staticClass: "mx-2",
    attrs: {
      "variant": "outlined",
      "size": "sm",
      "color": "alternative"
    },
    on: {
      "click": _vm.popupBulkBook
    }
  }, [_vm._v(" Bulk Action ")]), _c('Button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "outlined",
      "size": "sm",
      "color": "alternative"
    },
    on: {
      "click": _vm.toggleDropdown
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-filter"
  }), _vm._v(" Filter "), _c('i', {
    staticClass: "fa-solid fa-chevron-down"
  })]), _c('FilterComponent', {
    attrs: {
      "isDropdownVisible": _vm.isDropdownVisible,
      "statusProp": this.status,
      "vendorProp": this.vendor
    },
    on: {
      "update:isDropdownVisible": function ($event) {
        _vm.isDropdownVisible = $event;
      },
      "update:is-dropdown-visible": function ($event) {
        _vm.isDropdownVisible = $event;
      },
      "reloadPage": _vm.reloadPage,
      "input": _vm.handleFilterInput
    }
  })], 1)]), _c('div', [_c('div', {
    staticClass: "flex justify-start items-center px-3 mb-3"
  }, [_c('div', {
    staticClass: "mr-2"
  }, [_c('Label', {
    staticClass: "bg-white text-sm px-0",
    attrs: {
      "variant": "gray"
    }
  }, [_vm._v(" Show ")])], 1), _c('div', {
    staticClass: "mr-4"
  }, [_c('Label', {
    staticClass: "bg-white",
    class: {
      'opacity-50': _vm.isLoading
    },
    attrs: {
      "variant": "gray"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filterByStatusRadio,
      expression: "filterByStatusRadio"
    }],
    staticClass: "mr-1",
    class: {
      'opacity-50': _vm.isLoading
    },
    attrs: {
      "type": "radio",
      "disabled": _vm.isLoading,
      "checked": "",
      "value": "all",
      "name": "statusFilter"
    },
    domProps: {
      "checked": _vm._q(_vm.filterByStatusRadio, "all")
    },
    on: {
      "change": [function ($event) {
        _vm.filterByStatusRadio = "all";
      }, function ($event) {
        return _vm.filterByStatus('all');
      }]
    }
  }), _vm._v(" All ")])], 1), _c('div', {
    staticClass: "mr-4"
  }, [_c('Label', {
    staticClass: "bg-white",
    class: {
      'opacity-50': _vm.isLoading
    },
    attrs: {
      "variant": "gray"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filterByStatusRadio,
      expression: "filterByStatusRadio"
    }],
    staticClass: "mr-1",
    class: {
      'opacity-50': _vm.isLoading
    },
    attrs: {
      "disabled": _vm.isLoading,
      "type": "radio",
      "name": "statusFilter",
      "value": "ready for upload"
    },
    domProps: {
      "checked": _vm._q(_vm.filterByStatusRadio, "ready for upload")
    },
    on: {
      "change": [function ($event) {
        _vm.filterByStatusRadio = "ready for upload";
      }, function ($event) {
        return _vm.filterByStatus('ready for upload');
      }]
    }
  }), _vm._v(" Ready For Upload ")])], 1), _c('div', {
    staticClass: "mr-4"
  }, [_c('Label', {
    staticClass: "bg-white",
    class: {
      'opacity-50': _vm.isLoading
    },
    attrs: {
      "variant": "gray"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filterByStatusRadio,
      expression: "filterByStatusRadio"
    }],
    staticClass: "mr-1",
    class: {
      'opacity-50': _vm.isLoading
    },
    attrs: {
      "disabled": _vm.isLoading,
      "type": "radio",
      "name": "statusFilter",
      "value": "failed to upload"
    },
    domProps: {
      "checked": _vm._q(_vm.filterByStatusRadio, "failed to upload")
    },
    on: {
      "change": [function ($event) {
        _vm.filterByStatusRadio = "failed to upload";
      }, function ($event) {
        return _vm.filterByStatus('failed to upload');
      }]
    }
  }), _vm._v(" Failed to Upload ")])], 1), _c('div', [_c('Label', {
    staticClass: "bg-white",
    class: {
      'opacity-50': _vm.isLoading
    },
    attrs: {
      "variant": "gray"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filterByStatusRadio,
      expression: "filterByStatusRadio"
    }],
    staticClass: "mr-1",
    class: {
      'opacity-50': _vm.isLoading
    },
    attrs: {
      "type": "radio",
      "disabled": _vm.isLoading,
      "name": "statusFilter",
      "value": "need approval"
    },
    domProps: {
      "checked": _vm._q(_vm.filterByStatusRadio, "need approval")
    },
    on: {
      "change": [function ($event) {
        _vm.filterByStatusRadio = "need approval";
      }, function ($event) {
        return _vm.filterByStatus('need approval');
      }]
    }
  }), _vm._v(" Need Approval ")])], 1)]), _c('TableBooks', {
    staticClass: "border-b border-gray-50",
    attrs: {
      "id": "my-table",
      "books": _vm.ebooks,
      "currentPage": _vm.currentPage,
      "perPage": _vm.perPage,
      "isLoading": _vm.isLoading,
      "reloadPage": _vm.reloadPage
    },
    on: {
      "sort-by": _vm.handleSortBy
    }
  })], 1), _vm.ebooks.length ? _c('div', {
    staticClass: "flex bg-white justify-between pl-5 pr-3 pt-4 mb-5 border-t border-gray-100 mt-1"
  }, [_c('div', {
    staticClass: "font-semibold"
  }, [_c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("Showing ")]), _vm._v(" " + _vm._s(_vm.currentPage) + "-" + _vm._s(_vm.perPage) + " "), _c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("of")]), _vm._v(" " + _vm._s(_vm.formatPriceBasic(_vm.totalRows)) + " ")]), _c('div', {
    staticClass: "mb-2"
  }, [_c('t-pagination', {
    attrs: {
      "total-items": Number(_vm.totalRows),
      "per-page": _vm.perPage
    },
    on: {
      "change": _vm.onClickPage
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)]) : _vm._e(), _c('t-modal', {
    ref: "openBulk"
  }, [_c('div', {
    staticClass: "text-sm flex-col text-left"
  }, [_c('label', {
    staticClass: "text-left text-lg font-semibold"
  }, [_vm._v("Bulk Action")]), [_c('div', {
    staticClass: "space-y-6"
  }, [_c('div', {
    staticClass: "flex items-center p-2.5 justify-start rounded-2xl border-2 cursor-pointer",
    class: _vm.selectedBulk === 'metadata' ? 'border-gray-200 bg-gray-50' : 'border-gray-200',
    on: {
      "click": function ($event) {
        return _vm.selectOption('metadata');
      }
    }
  }, [_c('div', {
    staticClass: "w-5 h-5 mr-2 rounded-full border-2 flex items-center justify-center",
    class: _vm.selectedBulk === 'metadata' ? 'border-gray-200' : 'border-gray-300'
  }, [_vm.selectedBulk === 'metadata' ? _c('div', {
    staticClass: "w-3 h-3 rounded-full bg-blue-500"
  }) : _vm._e()]), _c('div', [_c('h3', {
    staticClass: "text-base mb-0 font-semibold text-gray-900"
  }, [_vm._v(" Bulk Import Metadata ")]), _c('p', {
    staticClass: "text-gray-500 text-xs mt-0 mb-1"
  }, [_vm._v(" Using .CSV file to create meta data details. ")])])]), _c('div', {
    staticClass: "flex items-center p-2.5 justify-start rounded-2xl border cursor-pointer",
    class: _vm.selectedBulk === 'upload' ? 'border-gray-200 bg-gray-50' : 'border-gray-200',
    on: {
      "click": function ($event) {
        return _vm.selectOption('upload');
      }
    }
  }, [_c('div', {
    staticClass: "w-5 h-5 mr-2 rounded-full border flex items-center justify-center",
    class: _vm.selectedBulk === 'upload' ? 'border-gray-200' : 'border-gray-200'
  }, [_vm.selectedBulk === 'upload' ? _c('div', {
    staticClass: "w-3 h-3 rounded-full bg-blue-500"
  }) : _vm._e()]), _c('div', [_c('h3', {
    staticClass: "text-base mb-0 font-semibold text-gray-900"
  }, [_vm._v(" Bulk Upload File Books ")]), _c('p', {
    staticClass: "text-gray-500 text-xs mt-0 mb-1"
  }, [_vm._v(" Import content PDF/EPUB books simultaneously. ")])])])])]], 2), _c('div', {
    staticClass: "flex justify-left mt-3 space-x-3"
  }, [_c('Button', {
    staticClass: "flex justify-items-start items-center",
    attrs: {
      "variant": "default",
      "color": "primary",
      "size": "xs"
    },
    on: {
      "click": _vm.nextUpload
    }
  }, [_vm._v(" Next ")]), _c('Button', {
    staticClass: "flex justify-items-start items-center",
    attrs: {
      "variant": "outlined",
      "color": "alternative",
      "size": "xs"
    },
    on: {
      "click": _vm.cancelpopup
    }
  }, [_vm._v(" Cancel ")])], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }